<template>
  <div class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入作业活动名称"
        v-model="equipSearchData.keywords"
        clearable
      ></el-input>
      <el-select
        v-model="equipSearchData.riskRatingMethodType"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择评价方法"
        clearable
      >
        <el-option
          v-for="item in planStatusList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        v-model="equipSearchData.assessmentStatus"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择评估状态"
        clearable
      >
        <el-option
          v-for="item in resultList"
          :key="item.code"
          :label="item.displayName"
          :value="item.code"
        ></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="handleSearch()"
        >搜索</el-button
      >
      <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        :span-method="spanMethod"
        v-loading="equipTableLoading"
        :row-class-name="rowClassName"
        @cell-mouse-enter="handleMouseEnter"
        @cell-mouse-leave="handleMouseLeave"
      >
        <el-table-column label="序号" prop="specialId" width="50"></el-table-column>
        <el-table-column
          label="辨识计划"
          width="180"
          prop="recognitionPlanName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="计划截止时间" prop="planTimeEnd" show-overflow-tooltip width="180">
          <template slot-scope="scope">
            {{
              scope.row.planTimeEnd && dayjs(scope.row.planTimeEnd).format('YYYY-MM-DD HH:mm:ss')
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="评估状态"
          prop="riskAssessStatusStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="作业活动名称"
          width="180"
          prop="jobName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="作业活动编号"
          width="180"
          prop="jobNo"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="作业步骤" prop="jobStep" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="危险源或潜在事件"
          prop="hiddenEvent"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="危险有害因素分类"
          prop="harmElementType"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="可能导致的事故类型"
          width="180"
          prop="accidentType"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="是否重点管控"
          width="110"
          prop="isFocusControl"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isFocusControl === 0 || scope.row.isFocusControl === '0'"
              >否</span
            >
            <span v-else-if="scope.row.isFocusControl === 1 || scope.row.isFocusControl === '1'"
              >是</span
            >
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column
          label="伤亡财产损失预测"
          prop="assetsCasualtyPredict"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="LS评估方法"
          width="180"
          prop="riskRatingMethodLS"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="LEC评估方法"
          width="180"
          prop="riskRatingMethodLEC"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="D/R风险值"
          width="180"
          prop="dRiskValue"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="评价级别"
          width="180"
          prop="evaluationLevel"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="管控级别"
          width="180"
          prop="controlLevel"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="260">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <risk-job-form
      v-if="formDialog"
      :taskId="taskId"
      :evaluateMethod="evaluateMethod"
      :projectId="projectId"
      :identifyId="identifyId"
      :formProps="formProps"
      @refreshList="handleRefresh"
      @cancel="handleBack"
    ></risk-job-form>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import { SourcesDangerRecognitionRiskRatingApi } from '@wiz-api/double-prevention-management'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import utils from '@/components/safety/enumField/utils'
import RiskJobForm from './RiskJobForm'

const areaApi = new AreaApi()
const sourcesDangerRecognitionRiskRatingApi = new SourcesDangerRecognitionRiskRatingApi()

export default {
  name: 'evaluate-job-table',
  components: {
    TableOperateButton,
    RiskJobForm,
  },
  data() {
    return {
      taskId: null,
      projectId: null,
      identifyId: null,
      cellIndex: -1,
      rowIndex: 1,
      position: 0,
      spanArrObj: {},
      evaluateMethod: null,
      formProps: {
        title: '新增作业活动评估',
        editType: 'create',
        visible: true,
      },
      value: '',
      formDialog: false,
      areaList: [],
      planStatusList: [],
      resultList: [
        {
          code: 0,
          displayName: '待评估',
        },
        {
          code: 1,
          displayName: '已评估',
        },
        {
          code: 2,
          displayName: '已逾期',
        },
      ],
      // 作业活动清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        type: '',
        readStatus: '',
        title: '',
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '提交',
            click: () => {
              return this.handleEvent(val, 'submit')
            },
            isShow:
              this.$hasAccess('submit') && val.riskAssessStatus !== 2 && !val.riskRatingStatus,
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow:
              this.$hasAccess('update') && val.riskAssessStatus !== 2 && !val.riskRatingStatus,
          },
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
        ]
      }
    },
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
  },
  async created() {
    // tagType 1为设备设施 2为作业活动 3为基础管理
    if (
      this.$route.query.id &&
      this.$route.query.tagType &&
      this.$route.query.tagType == 2 &&
      this.$route.query.mode
    ) {
      const data = {
        maxResultCount: 1, // 每页多少条
        skipCount: 0, // 跳过多少条
        palanId: this.$route.query.id,
        dangerIdentifyId: this.$route.query.jobSourcesDangerIdentifyId,
      }
      // 获取详情
      const [err, res] = await sourcesDangerRecognitionRiskRatingApi.jobRiskAssessPagedListQuery(
        data
      )
      if (!err) {
        this.handleEvent(res.items[0], this.$route.query.mode === 'approve' ? 'todoSubmit' : 'read')
      }
    }
    this.getEquipList()
    // 获取区域列表
    this.getAreaList()
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.EvaluateMethods'],
      ['planStatusList'],
      this
    )
  },
  methods: {
    // 返回
    async handleBack() {
      if (this.$route.query.id) {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== this.$route.path
            })
          )
        }
        this.$router.go(-1)
      }
      this.formDialog = false
    },
    // 保存刷新
    handleRefresh() {
      if (this.$route.query.id) {
        this.$router.replace(this.$route.path)
        this.$router.go(-1)
      }
      this.formDialog = false
      this.getEquipList()
    },
    // 重置
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.handleSearch()
    },
    // 获取合并行参数(数组)
    rowspan(data) {
      const list = []
      this.rowIndex = 1
      this.position = 0
      this.spanArrObj = {}
      _.forEach(data, (item, index) => {
        item.riskAssessStatusParent = item.riskAssessStatus
        if (
          item.jobSourcesDangerIdentifyAssessDtos &&
          item.jobSourcesDangerIdentifyAssessDtos.length > 0
        ) {
          _.forEach(item.jobSourcesDangerIdentifyAssessDtos, (ele) => {
            ele.cellIndex = index
            list.push({ ...item, ...ele })
          })
        } else {
          list.push({ ...item })
        }
      })
      list.forEach((item, index) => {
        if (index === 0) {
          if (!this.spanArrObj.sourcesDangerRecognitionPlanTaskId) {
            this.spanArrObj.sourcesDangerRecognitionPlanTaskId = []
          }
          this.spanArrObj.sourcesDangerRecognitionPlanTaskId.push(1)
          this.position = 0
          item.specialId = this.rowIndex
          // eslint-disable-next-line no-plusplus
          this.rowIndex++
        } else if (
          list[index].sourcesDangerRecognitionPlanTaskId ===
          list[index - 1].sourcesDangerRecognitionPlanTaskId
        ) {
          this.spanArrObj.sourcesDangerRecognitionPlanTaskId[this.position] += 1
          this.spanArrObj.sourcesDangerRecognitionPlanTaskId.push(0)
        } else {
          if (!this.spanArrObj.sourcesDangerRecognitionPlanTaskId) {
            this.spanArrObj.sourcesDangerRecognitionPlanTaskId = []
          }
          item.specialId = this.rowIndex
          // eslint-disable-next-line no-plusplus
          this.rowIndex++
          this.spanArrObj.sourcesDangerRecognitionPlanTaskId.push(1)
          this.position = index
        }
      })
      this.equipDataList = list
    },
    // 合并行方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 2, 3, 4, 5].includes(columnIndex)) {
        const _row = this.spanArrObj.sourcesDangerRecognitionPlanTaskId[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
    // 鼠标进入单元格
    handleMouseEnter(row, column, cell, event) {
      _.forEach(this.equipDataList, (item, index) => {
        if (row.specialId === item.cellIndex) {
          this.cellIndex = row.cellIndex
        }
      })
    },
    // rowIndex添加类名
    rowClassName({ row, rowIndex }) {
      let r = -1
      _.forEach(this.equipDataList, (item) => {
        if (this.cellIndex === row.cellIndex) {
          r = rowIndex
        }
      })
      if (rowIndex === r) {
        return 'hover-row'
      }
    },
    // 鼠标离开单元格
    handleMouseLeave(row, column, cell, event) {
      this.cellIndex = -1
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 列表操作-事件 作业活动清单
    async handleEvent(row = null, operation) {
      if (['update', 'todoSubmit'].includes(operation) && this.planIsOverdue(row.planTimeEnd)) {
        this.$message.warning('任务已逾期,无法进行操作')
        return
      }
      if (this.$route.query.jobSourcesDangerIdentifyId) {
        // 辨识id，管控和评级别保存需要用到的id, 查看管控需要用到id
        this.identifyId = row.jobSourcesDangerIdentifyAssessDtos[0].jobSourcesDangerIdentifyId
        // 查危险辨识详情需要用到id
        this.taskId = row.sourcesDangerRecognitionPlanTaskId
        // 查评级详情需要用到id
        this.projectId =
          row.jobSourcesDangerIdentifyAssessDtos[0].sourcesDangerRecognitionRiskRatingId || ''
        // 评价方法需要用于展示和评级保存
        this.evaluateMethod = row.evaluateMethod
      } else {
        // 辨识id，管控和评级别保存需要用到的id, 查看管控需要用到id
        this.identifyId = row.jobSourcesDangerIdentifyId
        // 查危险辨识详情需要用到id
        this.taskId = row.sourcesDangerRecognitionPlanTaskId
        // 查评级详情需要用到id
        this.projectId = row.sourcesDangerRecognitionRiskRatingId
        // 评价方法需要用于展示和评级保存
        this.evaluateMethod = row.evaluateMethod
      }
      switch (operation) {
        case 'submit':
          this.initDialog(operation)
          break
        case 'todoSubmit':
          this.initDialog(operation)
          break
        case 'update':
          this.initDialog(operation)
          break
        case 'read':
          this.initDialog(operation)
          break
        default:
          break
      }
    },
    // 判断当前辨识计划是否已逾期
    planIsOverdue(endDate) {
      let overdue = false
      const nowDateString = dayjs().unix()
      const endDateString = dayjs(endDate).unix()
      if (nowDateString > endDateString) {
        // 已逾期
        overdue = true
      }
      return overdue
    },
    // 弹窗初始化操作
    initDialog(operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      this.formDialog = true
    },
    // 搜索 作业活动
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 作业活动列表
    async getEquipList() {
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await sourcesDangerRecognitionRiskRatingApi.jobRiskAssessPagedListQuery(
        data
      )
      if (!err) {
        this.rowspan(res.items)
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style></style>
